import { render, staticRenderFns } from "./set-up.vue?vue&type=template&id=c322e440&scoped=true&"
import script from "./set-up.vue?vue&type=script&lang=js&"
export * from "./set-up.vue?vue&type=script&lang=js&"
import style0 from "./set-up.vue?vue&type=style&index=0&id=c322e440&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c322e440",
  null
  
)

export default component.exports